import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';


import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import ShowProformaInvoice from "components/product/components/price-calculation/ShowProformaInvoice";
import FieldView2 from "core/components/layout/FieldView2";
import CommentMgmt from "../comment/CommentMgmt";
import { setProductUpdateproductModal, setSelectedProductId, setSelectedPharmaorderId } from "store/slice/PharmaSlice";
import UpdateproductActionModal from "components/product/action/updateproduct/UpdateproductActionModal";

export default function TaskSpaceMD() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const { commentList } = useSelector(state => state.appslice.wkflow);
  const [localProductList, setLocalProductList] = useState([]);
  const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const { productList } = useSelector((state) => state.pharmaslice);
  const [expandPdf, setExpandPdf] = useState(false);

  useEffect(() => {
    dispatch(setSelectedPharmaorderId(productObj.orderid));
    dispatch(setCompleteTaskButtonEnabled(true));
    setLocalProductList(productList.filter(product => product.orderid === productObj.orderid && (
      product.statusname!=='CANCELLED' && product.overallstatusid!==10)));
  }, []);
  useEffect(() => {
    if (commentList && commentList.length > 0) {
      dispatch(setReferbackTaskButtonEnabled(true));
    }
  }, [commentList]);

  useEffect(()=>{
    
  },[taskCompleted])

  const editProduct = (product) => {
    //dispatch(setSelectedProductId(product.id));
    dispatch(setProductUpdateproductModal(true));
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
      {taskCompleted?
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ShowProformaInvoice />
          </Grid>
        </Grid>
      :
        <>
          <Grid container sx={{ width: '100%' }}>
            <Grid item lg={expandPdf ? 11 : 8} md={4} sm={4} xs={12}>
              <ShowProformaInvoice />
            </Grid>
            {expandPdf ? (
              <Grid item lg={1} md={8} sm={8} xs={12} sx={{p:2}}>
                <Box
                  sx={{
                    p:2,
                  // height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    backgroundColor: 'primary.dark',
                    borderRadius:2
                    
                  }}
                >
                  <KeyboardDoubleArrowLeftIcon
                    size="small"
                    onClick={() => setExpandPdf(!expandPdf)}
                    sx={{
                      cursor: 'pointer',
                      color:'white',
                      borderRadius: 2,
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  />
                </Box>
              </Grid>
            ) : <Grid item lg={4} md={8} sm={8} xs={12} sx={{ pl: 2, }}>
              <Grid container sx={{ width: '100%', backgroundColor: 'white', p: 1, borderRadius: 2 }}>
                <Grid item lg={11} md={11} sm={11} xs={11} sx={{ borderRadius: 2, mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>Product(s)</Typography>
                </Grid>
                <Grid item lg={1} md={1} sm={1} xs={1} sx={{ backgroundColor: 'white' }}>
                  <Box sx={{ p:1,
                  // height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    backgroundColor: 'primary.dark',
                    borderRadius:2}}>
                  <KeyboardDoubleArrowRightIcon
                    size="small"
                    onClick={() => setExpandPdf(!expandPdf)}
                    sx={{ cursor: 'pointer', color:'white',}}
                  >
                  </KeyboardDoubleArrowRightIcon>
                  </Box>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} sx={{ borderRadius: 2, mb: 2 }}>

                  <Grid container direction="row" sx={{ width: '100%', }}>
                    {localProductList.map((product, index) => (
                      <Grid item lg={12} md={12} sm={12} xs={12} key={index} sx={{display:productObj.id !== product.id?'none':'block', mb: 2, pr: 1 }}>
                        <Box sx={{ backgroundColor: productObj.id === product.id ? 'primary.darker' : 'white', color: productObj.id === product.id ? 'white' : '', borderRadius: 2, p: 1, cursor: 'pointer' }} onClick={() => dispatch(setSelectedProductId(product.id))}>
                          <Typography variant="h5" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {product.brandname}
                            <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                              <EditIcon onClick={() => editProduct(product)} />
                            </Box>
                          </Typography>
                          <Typography variant="h6" color="primary">{product.title}</Typography>
                        </Box>
                      </Grid>
                    ))}

                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{ borderRadius: 2, }}>
                  <Divider />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{ borderRadius: 2, }}>
                  <Box sx={{ width: '100%', backgroundColor: "white", borderRadius: 2, p: 1 }}>
                    <CommentMgmt maxHeight='50vh' />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            }
          </Grid>
          <UpdateproductActionModal />
        </>

      }
  </Grid>

  );
}